import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  display: inline-block;
  
  ${props => {
    switch (props.size) {
      case 'small':
        return 'width: 16px; height: 16px;';
      case 'large':
        return 'width: 40px; height: 40px;';
      default:
        return 'width: 24px; height: 24px;';
    }
  }}
`;

function LoadingSpinner({ size = 'medium' }) {
  return <Spinner size={size} />;
}

export default LoadingSpinner;
